import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { PageContainer } from '../../../common/components/PageContainer';
import { PillTabs } from '../../../components/design-system/admin';
import { AI_CHANNELS_TABS, AiChannelsTab, tabFrom } from '../../../modules/vendor/ai-channels/ai-channels';
import { VisibilityTab } from '../../../modules/vendor/ai-channels/VisibilityTab';
import { AssistantsTab } from '../../../modules/vendor/ai-channels/AssistantsTab';

/**
 * Being where shoppers ask AI (feat/room-to-revenue, workstream E).
 *
 * Visibility: when a shopper asks ChatGPT or Perplexity where to buy what you
 * sell, are you named? Assistants: put the catalogue inside those assistants
 * (an MCP server, a schema.org feed and llms.txt) and try it. ?tab=visibility | assistants
 */
export const AiChannelsPage = () => {
    const { t } = useTranslation();
    const [params, setParams] = useSearchParams();
    const tab = tabFrom(params.get('tab'));

    const choose = (next: AiChannelsTab) => {
        const p = new URLSearchParams(params);
        p.set('tab', next);
        setParams(p, { replace: true });
    };

    return (
        <PageContainer breadcrumbs={[{ label: t('WORKSPACE.BUSINESS') }, { label: t('R2R.NAV.AI') }]}>
            <div className="mx-auto flex w-full max-w-5xl flex-col gap-6" data-testid="ai-channels-page">
                <div className="flex flex-wrap items-end justify-between gap-4">
                    <div>
                        <h1 className="font-heading text-2xl font-medium tracking-tight">{t('AI_CHANNELS.TITLE')}</h1>
                        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{t('AI_CHANNELS.SUBTITLE')}</p>
                    </div>
                    <PillTabs
                        value={tab}
                        onChange={choose}
                        ariaLabel={t('AI_CHANNELS.TITLE') as string}
                        options={AI_CHANNELS_TABS.map((value) => ({ value, label: t(`AI_CHANNELS.TABS.${value.toUpperCase()}`) }))}
                    />
                </div>
                {tab === 'visibility' ? <VisibilityTab onOpenAssistants={() => choose('assistants')} /> : <AssistantsTab />}
            </div>
        </PageContainer>
    );
};

export default AiChannelsPage;
